import { CallClientState, ChatClientState, StatefulCallClient, StatefulChatClient } from "@azure/communication-react";
import { useRefreshThreadStates } from "./useRefreshThreadStates";
import { useEffect, useMemo } from "react";
import { groupChatThreadTopic } from "../chatConstants";
import { ChatThreadCreatedEvent, ChatThreadDeletedEvent } from "@azure/communication-chat";
import { PcpLiveLessonStore } from "../pcpLiveLessonStore";

export const useSyncClientStates = (store: PcpLiveLessonStore, callClient: StatefulCallClient, chatClient: StatefulChatClient) => {

    const setCallClientState = store.getState().setCallClientState;
    const setChatClientState = store.getState().setChatClientState;
    const updateGroupChatThreadId = store.getState().updateGroupChatThreadId;

    useRefreshThreadStates(chatClient);


    const threads = chatClient.getState().threads;

    // Find the group chat thread ID based on the topic
    const groupChatThreadId = useMemo(() => {
    const groupChat = Object
        .values(threads)
        .find(t => t.properties?.topic === groupChatThreadTopic);

        return groupChat?.threadId;
    }, [threads]);

    useEffect(() => {
        if (groupChatThreadId) {
            updateGroupChatThreadId(groupChatThreadId);
        }
    }, [groupChatThreadId, updateGroupChatThreadId]);

    useEffect(() => {
        // Listen on ChatThread creation and deletions:
        // The main thread (group chat) can get deleted and replaced by a new main thread
        // = chat gets cleared (as clearing a thread is not possible)

        const handleChatThreadCreated = (e: ChatThreadCreatedEvent) => {
            if (e.properties.topic === groupChatThreadTopic) {
                // dispatch({ type: "SET_GROUP_CHAT", threadId: e.threadId });
                updateGroupChatThreadId(e.threadId);
            }
        };

        const handleChatThreadDeleted = (e: ChatThreadDeletedEvent) => {
            console.warn("Chat thread deleted:", e);
        };

        chatClient.on("chatThreadCreated", handleChatThreadCreated);
        chatClient.on("chatThreadDeleted", handleChatThreadDeleted);

        return () => {
            chatClient.off("chatThreadCreated", handleChatThreadCreated);
            chatClient?.off("chatThreadDeleted", handleChatThreadDeleted);
        };
    }, [chatClient, updateGroupChatThreadId]);

    useEffect(() => {
        const syncCallClientState = (state: CallClientState) => {
            setCallClientState(state);
        };

        callClient.onStateChange(syncCallClientState);

        // Cleanup function for React components
        return () => {
            callClient.offStateChange(syncCallClientState);
        };
    }, [callClient, setCallClientState]);


    useEffect(() => {
        const syncChatClientState = (state: ChatClientState) => {
            setChatClientState(state);
        };

        chatClient.onStateChange(syncChatClientState);

        // Cleanup function for React components
        return () => {
            chatClient.offStateChange(syncChatClientState);
        };
    }, [chatClient, setChatClientState]);
};
